<template>
  <!-- MODULE PHOTO ORDER -->
  <v-flex
    class="pa-1"
    xs12
    sm6
    lg4
    xl3
    v-if="
      $store.state.storeClient.client.modules.modulePhotoOrder.active &&
      $store.state.storeClient.client.modules.modulePhotoOrder.show
    "
  >
    <v-card
      :class="
        getTheme() == 'dark' ? 'outlined elevation-0' : 'flat elevation-0'
      "
      :style="
        getTheme() == 'dark'
          ? 'border: 1px solid darkgray'
          : 'border-bottom: 1px solid lightgray'
      "
    >
      <v-img
        class="align-start hover-item"
        height="140px"
        :src="
          $store.state.storeClient.client.modules.modulePhotoOrder.menuImage
            .length > 0
            ? $store.state.storeClient.client.modules.modulePhotoOrder.menuImage
            : usersNewOrderImage
        "
        @click="$router.push({ name: 'userNewOrderBasic' })"
      >
        <v-card-title class="overline text-no-wrap">
          <span
            v-if="
              $store.state.storeClient.client.modules.modulePhotoOrder.subtitle
                .length > 0
            "
            :style="
              $store.state.storeClient.client.modules.modulePhotoOrder.whiteText
                ? 'color: whitesmoke'
                : 'color: #505050'
            "
          >
            {{
              $store.state.storeClient.client.modules.modulePhotoOrder.subtitle
            }}
          </span>
          <span
            v-else
            :style="
              $store.state.storeClient.client.modules.modulePhotoOrder.whiteText
                ? 'color: whitesmoke'
                : 'color: #505050'
            "
            >{{ $t("dashboardCardModulePhotoOrderUserTitle") }}</span
          >
        </v-card-title>
        <v-card-subtitle class="text-no-wrap body-1 font-weight-black pb-3">
          <span
            v-if="
              $store.state.storeClient.client.modules.modulePhotoOrder.title
                .length > 0
            "
            :style="
              $store.state.storeClient.client.modules.modulePhotoOrder.whiteText
                ? 'color: whitesmoke'
                : 'color: #505050'
            "
          >
            {{ $store.state.storeClient.client.modules.modulePhotoOrder.title }}
          </span>
          <span
            v-else
            :style="
              $store.state.storeClient.client.modules.modulePhotoOrder.whiteText
                ? 'color: whitesmoke'
                : 'color: #505050'
            "
            >{{ $t("dashboardCardModulePhotoOrderUserSubTitle") }}</span
          >
        </v-card-subtitle>
      </v-img>
      <v-card-actions
        :style="
          getTheme() == 'dark'
            ? 'background-color: #505050'
            : 'background-color: white'
        "
      >
        <v-spacer></v-spacer>
        <home-menu-card-action-btn
          outlined
          path="/userNewOrderBasic"
          icon="mdi-folder-plus"
          :title="$t('dashboardCardModulePhotoOrderUserOrderButtonTitle')"
        ></home-menu-card-action-btn>
        <v-spacer></v-spacer>
        <home-menu-card-action-btn
          path="/userImagePrices"
          icon="mdi-cash-multiple"
          :title="$t('dashboardCardModulePhotoOrderPricesButtonTitle')"
        ></home-menu-card-action-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
      <home-menu-edit-card-btn
        path="/settingsPhotoOrderBasic"
      ></home-menu-edit-card-btn>
    </v-card>
    <!-- če je aktivnih več kod, potem prikažemo carousel -->
    <!--<v-card
      v-else
      :class="
        getTheme() == 'dark' ? 'outlined elevation-0' : 'flat elevation-0'
      "
      :style="
        getTheme() == 'dark'
          ? 'border: 1px solid darkgray'
          : 'border-bottom: 1px solid lightgray'
      "
    >
      <v-carousel
        height="140"
        cycle
        hide-delimiter-background
        show-arrows-on-hover
        v-bind:show-arrows="false"
      >
        <div v-for="(item, index) in activeModPhotoOrderPromoCodes" :key="index">
          <v-carousel-item>
            <v-img
              class="align-start hover-item"
              height="140px"
              :src="
                $store.state.storeClient.client.modules.modulePhotoOrder
                  .menuImage.length > 0
                  ? $store.state.storeClient.client.modules.modulePhotoOrder
                      .menuImage
                  : usersNewOrderImage
              "
              @click="$router.push({ name: 'userNewOrderBasic' })"
            >
              <v-card-title class="overline text-no-wrap">
                <span
                  v-if="
                    $store.state.storeClient.client.modules.modulePhotoOrder
                      .subtitle.length > 0
                  "
                  :style="
                    $store.state.storeClient.client.modules.modulePhotoOrder
                      .whiteText
                      ? 'color: whitesmoke'
                      : 'color: #505050'
                  "
                >
                  {{
                  $store.state.storeClient.client.modules.modulePhotoOrder
                  .subtitle
                  }}
                </span>
                <span
                  v-else
                  :style="
                    $store.state.storeClient.client.modules.modulePhotoOrder
                      .whiteText
                      ? 'color: whitesmoke'
                      : 'color: #505050'
                  "
                >{{ $t("dashboardCardModulePhotoOrderUserTitle") }}</span>
              </v-card-title>
              <v-card-subtitle class="text-no-wrap body-1 font-weight-black pb-3">
                <span
                  v-if="
                    $store.state.storeClient.client.modules.modulePhotoOrder
                      .title.length > 0
                  "
                  :style="
                    $store.state.storeClient.client.modules.modulePhotoOrder
                      .whiteText
                      ? 'color: whitesmoke'
                      : 'color: #505050'
                  "
                >
                  {{
                  $store.state.storeClient.client.modules.modulePhotoOrder
                  .title
                  }}
                </span>
                <span
                  v-else
                  :style="
                    $store.state.storeClient.client.modules.modulePhotoOrder
                      .whiteText
                      ? 'color: whitesmoke'
                      : 'color: #505050'
                  "
                >{{ $t("dashboardCardModulePhotoOrderUserSubTitle") }}</span>
              </v-card-subtitle>
              <div class="overline text-no-wrap mt-0 pt-0">
                <span class="error white--text pa-2">
                  <v-icon color="white">mdi-label-percent</v-icon>
                  {{ $t("userNewOrderSummary5aTitle") }}:
                  {{ item.promoCode }} (-{{ item.discount }}%)
                  <v-icon color="white" small>mdi-clock-outline</v-icon>
                  {{ daysLeftSince(item.validTo.seconds) }}
                  <v-icon v-if="!item.permanent" color="white" small class="mr-1">mdi-numeric-1-box</v-icon>
                </span>
              </div>
            </v-img>
          </v-carousel-item>
        </div>
      </v-carousel>
      <v-card-actions
        :style="
          getTheme() == 'dark'
            ? 'background-color: #505050'
            : 'background-color: white'
        "
      >
        <v-spacer></v-spacer>
        <home-menu-card-action-btn
          outlined
          path="/userNewOrderBasic"
          icon="mdi-folder-plus"
          :title="$t('dashboardCardModulePhotoOrderUserOrderButtonTitle')"
        ></home-menu-card-action-btn>
        <v-spacer></v-spacer>
        <home-menu-card-action-btn
          path="/userImagePrices"
          icon="mdi-cash-multiple"
          :title="$t('dashboardCardModulePhotoOrderPricesButtonTitle')"
        ></home-menu-card-action-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
      <home-menu-edit-card-btn path="/settingsPhotoOrderBasic"></home-menu-edit-card-btn>
    </v-card>-->
  </v-flex>
</template>

<script>
import HomeMenuEditCardBtn from "@/components/HomeMenuEditCardBtn";
import HomeMenuCardActionBtn from "@/components/HomeMenuCardActionBtn";

export default {
  name: "homeMenuModulePhotoOrder",
  components: {
    HomeMenuEditCardBtn,
    HomeMenuCardActionBtn,
  },
  data() {
    return {
      usersNewOrderImage: require("@/assets/usersNewOrder.jpg"),
    };
  },
  /*computed: {
    activeModPhotoOrderPromoCodes() {
      let arr = this.$store.state.storePromoCode.activePromoCodes.filter(
        (x) => x.module == G_MODULE_PHOTO_ORDER && !x.hidden
      );
      return arr;
    },
  },*/
};
</script>
